/**
 * Wall Edit Tool
 *
 * The wall sketch editor restricted to EDITING: selection, box-select, move,
 * perpendicular slide, thickness resize, bow/curvature, insert-vertex, radial
 * menu, and keyboard/right-click delete. All wall-CREATING gestures
 * (draw-wall, extrude-from-node/edge, empty-sketch bootstrap) are stripped —
 * creating walls is the WallCreateTool's job. Grabbing an unselected node or
 * wall selects it and moves it instead of extruding.
 *
 * Part of the wall mode in the floorplan persona.
 */

import { Viewer } from '../../../viewer/viewer';
import { IPersona } from '../../types';
import { WallSketchEditorTool } from './WallSketchEditorTool';

export class WallEditTool extends WallSketchEditorTool {
  override readonly name: string = 'wall_edit';

  constructor(viewer: Viewer, persona: IPersona) {
    super(viewer, persona, { allowCreate: false, allowSelect: true });
  }
}
